import { Switch } from "@/components/ui/switch";

export const inputCls = "w-full mt-2 bg-white/70 border border-border rounded-xl px-4 py-2.5 outline-none focus:border-accent transition-colors";

export const TextField = ({ k, label, content, setC, span, type = "text", ...rest }) => (
  <div className={span ? "md:col-span-2" : ""}>
    <label className="text-xs uppercase tracking-widest text-muted-foreground">{label}</label>
    <input type={type} data-testid={`content-${k}`} value={content[k] ?? ""} onChange={(e) => setC(k, e.target.value)} className={inputCls} {...rest} />
  </div>
);

export const SelectField = ({ k, label, value, onChange, options }) => (
  <div>
    <label className="text-xs uppercase tracking-widest text-muted-foreground">{label}</label>
    <select data-testid={`content-${k}`} value={value} onChange={(e) => onChange(e.target.value)} className={inputCls}>
      {options.map(([v, l]) => <option key={v} value={v}>{l}</option>)}
    </select>
  </div>
);

export const ColorField = ({ k, label, content, setC }) => {
  const v = content[k] || "";
  return (
    <div>
      <label className="text-xs uppercase tracking-widest text-muted-foreground">{label}</label>
      <div className="mt-2 flex items-center gap-2">
        <input type="color" data-testid={`content-${k}-picker`} value={v || "#1A2E26"} onChange={(e) => setC(k, e.target.value)} className="h-10 w-12 rounded-lg border border-border bg-white/70 p-1 cursor-pointer" />
        <input data-testid={`content-${k}`} value={v} onChange={(e) => setC(k, e.target.value)} placeholder="Theme default" className="flex-1 bg-white/70 border border-border rounded-xl px-4 py-2.5 outline-none focus:border-accent transition-colors" />
        {v && <button type="button" data-testid={`content-${k}-reset`} onClick={() => setC(k, "")} className="text-xs text-muted-foreground hover:text-foreground">Reset</button>}
      </div>
    </div>
  );
};


export const ToggleRow = ({ testId, label, sub, checked, onChange, className = "" }) => (
  <div className={`flex items-center justify-between gap-4 rounded-xl border border-border bg-white/50 px-4 py-3 ${className}`}>
    <div>
      <p className="text-sm font-medium">{label}</p>
      {sub && <p className="text-xs text-muted-foreground">{sub}</p>}
    </div>
    <div className="flex items-center gap-3 shrink-0">
      <span className={`text-xs font-medium ${checked ? "text-[#128C4B]" : "text-muted-foreground"}`}>{checked ? "Visible" : "Hidden"}</span>
      <Switch data-testid={testId} aria-label={`Toggle ${label}`} checked={checked} onCheckedChange={onChange} />
    </div>
  </div>
);

export const SaveButton = ({ saveContent, savingContent, testId = "content-save-btn" }) => (
  <button data-testid={testId} onClick={saveContent} disabled={savingContent} className="rounded-full bg-primary text-primary-foreground px-5 py-2 text-xs hover:-translate-y-0.5 transition-transform disabled:opacity-60">
    {savingContent ? "Saving…" : "Save content"}
  </button>
);
